import { UsersApiFactory, V1User } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { CompanyUser } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'

function createCompanyUsers(rawCompanyUsers?: V1User[]): CompanyUser[] {
  if (!rawCompanyUsers) return [] as CompanyUser[]

  return rawCompanyUsers.map((cu: V1User): CompanyUser => {
    return new CompanyUser({
      id: cu.id,
      companyId: cu.companyId,
      name: cu.name,
      mail: cu.mail
    })
  })
}

export const NewCompanyUsersApiFunc = () => {
  const webAdapter = UsersApiFactory(undefined, api.defaults.baseURL, api)

  return {
    listCompanyUsers: async (companyId: string, filter?: string, page?: number): Promise<ApiResponse<ListResponse<CompanyUser>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listUsers(companyId, filter, page)
        data = createCompanyUsers(res.data.users)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as CompanyUser[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    },

    getCompanyUser: async (companyId: string, companyUserId: string): Promise<ApiResponse<CompanyUser>> => {
      let data, err

      try {
        const res = await webAdapter.getUser(companyId, companyUserId)
        data = createCompanyUsers([res.data])[0]
      } catch (e) {
        data = new CompanyUser()
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    createCompanyUser: async (companyId: string, user: CompanyUser): Promise<ApiResponse<CompanyUser | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.createUser(companyId, {data: user})
        data = createCompanyUsers([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    updateCompanyUser: async (companyId: string, companyUserId: string, companyUser: CompanyUser): Promise<ApiResponse<CompanyUser | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updateUser(companyId, companyUserId, {data: companyUser})
        data = createCompanyUsers([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    deleteCompanyUser: async (companyId: string, companyUserId: string): Promise<ApiResponse<void>> => {
      let data, err

      try {
        await webAdapter.deleteUser(companyId, companyUserId)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    }
  }
}
